<template>
  <div class="space-y-6">
    <ReportTitle :title="$gettext('Rapport d\'organisation')" :date="report?.attributes?.createdAt" />
    <div v-if="company" class="nobreak">
      <h3 class="text-lg font-medium text-gray-800 mb-2">{{ $gettext("Identité") }}</h3>
      <div class="max-w-md">
        <dl class="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
          <dt class="font-medium text-gray-700">{{ $gettext("Dénomination Sociale") }}:</dt>
          <dd class="text-gray-900 font-bold">
            {{ company?.attributes?.name }}
          </dd>

          <dt class="font-medium text-gray-700">{{ $gettext("Numéro d'entreprise") }}:</dt>
          <dd class="text-gray-900 font-bold">
            {{ company?.attributes?.companyNumber }}
          </dd>

          <dt class="font-medium text-gray-700">{{ $gettext("Date de création") }}:</dt>
          <dd class="text-gray-900 font-bold">
            {{ parseDate(company?.attributes?.establishmentDate) }}
          </dd>

          <dt class="font-medium text-gray-700">{{ $gettext("Numéro de TVA") }}:</dt>
          <dd class="text-gray-900 font-bold">
            {{ company?.attributes?.vatNumber }}
          </dd>
          <dt class="font-medium text-gray-700">{{ $gettext("Représentants légaux") }}:</dt>
          <dd class="text-gray-900 font-bold">
            <p v-for="(representative, index) in signatories" :key="index">
              {{ representative?.attributes?.name }}
            </p>
          </dd>
          <dt class="font-medium text-gray-700">{{ $gettext("Bénéficiaires effectifs") }}:</dt>
          <dd class="text-gray-900 font-bold">
            <p v-for="(ubo, index) in beneficiaries" :key="index">
              {{ ubo?.attributes?.name }}
              <span v-if="ubo?.attributes?.ultimateBeneficiaryOwnerControlPercentage != null">({{
                ubo.attributes.ultimateBeneficiaryOwnerControlPercentage }}%)</span>
            </p>
          </dd>
        </dl>
      </div>
    </div>
    <div v-if="company" class="nobreak">
      <h3 class="text-lg font-medium text-gray-800 mb-2">{{ $gettext("Adresse") }}</h3>
      <p class="text-sm font-bold">
        {{ company?.attributes?.addressStreet }},
        {{ company?.attributes?.addressZipcode }}
        {{ company?.attributes?.addressCity }}
      </p>
    </div>
    <ReportRiskScoringBlock :riskScoring="riskScoring" :showSanctionsBlock="true" />
    <ReportDocumentsBlock :documents="company?.relationships?.companyDocuments?.data" />
  </div>
</template>

<script setup>
import ReportTitle from "@/components/reports/ReportTitle.vue";
import ReportDocumentsBlock from '@/components/reports/ReportDocumentsBlock.vue';
import { useGettext } from "vue3-gettext";
import ReportRiskScoringBlock from './ReportRiskScoringBlock.vue';
import { useDate } from "@/utils/stores/date";

const { parseDate } = useDate();
const { $gettext } = useGettext();

const props = defineProps({
  report: {
    type: Object,
    required: true
  }
});

const company = props.report?.attributes?.data;
const beneficiaries = company?.relationships?.companyUltimateBeneficialOwners?.data || [];
const signatories = company?.relationships?.signatories?.data || [];
const riskScoring =
  company?.relationships?.lastRiskScoring?.data
    ? company.relationships.lastRiskScoring.data
    : null;
</script>
